
import { Component, Prop, Vue } from 'vue-property-decorator'
import { BusinessCategory } from '../types'

interface CellBlock { text?: string; list?: string[] }
type CellValue = string | string[] | CellBlock[]

@Component
export default class ContentSection extends Vue {
  @Prop({ type: Object, required: true }) readonly category!: BusinessCategory

  /** Check if cell is a plain string */
  isString(cell: CellValue): cell is string {
    return typeof cell === 'string'
  }

  /** Check if cell is a plain string array */
  isStringArray(cell: CellValue): cell is string[] {
    return Array.isArray(cell) && cell.length > 0 && typeof cell[0] === 'string'
  }

  /** Check if cell is a mixed block array */
  isBlockArray(cell: CellValue): cell is CellBlock[] {
    return Array.isArray(cell) && cell.length > 0 && typeof cell[0] === 'object'
  }
}
